"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const RadixTooltip = __importStar(require("@radix-ui/react-tooltip"));
const react_1 = require("react");
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const Tooltip = (_a) => {
    var { content, onOpenChange, enabled = true, children } = _a, rest = __rest(_a, ["content", "onOpenChange", "enabled", "children"]);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [isTouch, setIsTouch] = (0, react_1.useState)(false);
    const handleOpenChange = (open) => {
        setIsOpen(open);
        if (onOpenChange) {
            onOpenChange(open);
        }
    };
    const handlePointerDownOutside = (event) => {
        var _a;
        const target = event.target;
        if (!((_a = event.currentTarget) === null || _a === void 0 ? void 0 : _a.contains(target))) {
            handleOpenChange(false);
        }
    };
    const handleTouchStart = () => {
        setIsTouch(true);
        handleOpenChange(true);
    };
    const handleMouseEnter = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!isTouch) {
            yield wait(100);
            handleOpenChange(true);
        }
    });
    const handleMouseLeave = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!isTouch) {
            yield wait(100);
            handleOpenChange(false);
        }
    });
    const handleTouchEnd = () => {
        setTimeout(() => {
            setIsTouch(false);
        }, 300);
    };
    return enabled ? ((0, jsx_runtime_1.jsx)(RadixTooltip.Provider, { children: (0, jsx_runtime_1.jsxs)(RadixTooltip.Root, { open: isOpen, children: [(0, jsx_runtime_1.jsx)(RadixTooltip.Trigger, { asChild: true, onTouchStart: handleTouchStart, onTouchEnd: handleTouchEnd, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: children }), (0, jsx_runtime_1.jsxs)(RadixTooltip.Content, Object.assign({ className: "TooltipContent" }, rest, { onPointerDownOutside: handlePointerDownOutside, children: [content, (0, jsx_runtime_1.jsx)(RadixTooltip.Arrow, { className: "TooltipArrow" })] }))] }) })) : (children);
};
exports.Tooltip = Tooltip;
